







































import Component from 'vue-class-component';
import forgotApi from '../../api/forgot.api';
import alertsApi from '@/api/alerts.api';
import accountsApi from '@/api/accounts.api';
// import { FormComponent } from '@/components/base/form/form.component';
import {IFormControl} from '@/entities/form.interface';
import {IDictionary} from '@/entities/dictionary.interface';
import {IConfirm, MeModel} from '@/entities';
import * as types from '@/store/types';
import authService from '../../services/auth.service';
// import {FormComponent} from '../../components/base/form/form.component';
import { FormComponent } from '@/components/base/form/form.component';

@Component({})
export default class ForgotPage extends FormComponent {

    public formState: IDictionary<IFormControl> = {
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required'
        },
        email: {
            key: 'email',
            label: 'Email',
            value: '',
            validators: 'required'
        }
    };

    public submit() {
        let username = this.formState.username.value;
        let email = this.formState.email.value;

        this.loading = true;
        forgotApi
            .forgot({
                username,
                email
            })
            .then((res: string) => {
                this.loading = false;
                this.$router.push('/login');
              })
            .catch((err) => this.processError(err));
    }

}
